<template>
    <div class="payout-distribution">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="font-weight-normal mb-0 text-muted">Commission</p>
                    <h2 class="listing-title d-inline-block mb-0">Payout</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button v-show="backButton" variant="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </b-button>
                    <b-button variant="primary" class="btn-header" @click="modals.show_new_hub = true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#ffffff" d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z"/></svg>
                        Reports
                    </b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <payout-listing-table></payout-listing-table>
        </b-container>
    </div>
</template>
<script>
import PayoutListingTable from '@/views/Commission/Payout/PayoutListingTable'
export default {
    components: {
        PayoutListingTable,
    },
    data() {
        return {
            backButton: false,
        };
    },
    created() {
        if(this.$route.params.token)
        {
            this.backButton = true;
        }
    },
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        }
    }
}
</script>